export default "__VITE_ASSET__il1ciMHt__"